<template>
  <v-panel>
    <v-form ref="form" v-model="valid" >
      <div class="divider">
        <span>
          <b>Dados das Despesas - Animais</b>
        </span>
      </div>
      <v-flex md11>
        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Compra de animais para recria e engorda</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Fêmeas +36 meses</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoCabecaFemeas36"
                  v-model="formulario.manutencaoCabecaFemeas36"
                  type="number"
                  background-color="white"
                  label="Cab"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoKGVivoFemeas36"
                  v-model="formulario.manutencaoKGVivoFemeas36"
                  type="number"
                  background-color="white"
                  label="Kg vivo/cab"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoRSCabFemea36"
                  v-model="formulario.manutencaoRSCabFemea36"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Fêmeas 24-36 meses</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoCabecaFemeas2436"
                  v-model="formulario.manutencaoCabecaFemeas2436"
                  type="number"
                  background-color="white"
                  label="Cab"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoKGVivoFemeas2436"
                  v-model="formulario.manutencaoKGVivoFemeas2436"
                  type="number"
                  background-color="white"
                  label="Kg vivo/cab"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoRSCabFemea2436"
                  v-model="formulario.manutencaoRSCabFemea2436"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Fêmeas 12-24 meses</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoCabecaFemeas1224"
                  v-model="formulario.manutencaoCabecaFemeas1224"
                  type="number"
                  background-color="white"
                  label="Cab"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoKGVivoFemeas1224"
                  v-model="formulario.manutencaoKGVivoFemeas1224"
                  type="number"
                  background-color="white"
                  label="Kg vivo/cab"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoRSCabFemea1224"
                  v-model="formulario.manutencaoRSCabFemea1224"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Fêmeas 0-12 meses</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoCabecaFemeas012"
                  v-model="formulario.manutencaoCabecaFemeas012"
                  type="number"
                  background-color="white"
                  label="Cab"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoKGVivoFemeas012"
                  v-model="formulario.manutencaoKGVivoFemeas012"
                  type="number"
                  background-color="white"
                  label="Kg vivo/cab"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoRSCabFemea012"
                  v-model="formulario.manutencaoRSCabFemea012"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Machos 0-12 meses</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoCabecaMachos012"
                  v-model="formulario.manutencaoCabecaMachos012"
                  type="number"
                  background-color="white"
                  label="Cab"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoKGVivoMachos012"
                  v-model="formulario.manutencaoKGVivoMachos012"
                  type="number"
                  background-color="white"
                  label="Kg vivo/cab"
                  box                  
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoRSCabMachos012"
                  v-model="formulario.manutencaoRSCabMachos012"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Machos 12-24 meses</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoCabecaMachos1224"
                  v-model="formulario.manutencaoCabecaMachos1224"
                  type="number"
                  background-color="white"
                  label="Cab"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoKGVivoMachos1224"
                  v-model="formulario.manutencaoKGVivoMachos1224"
                  type="number"
                  background-color="white"
                  label="Kg vivo/cab"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoRSCabMachos1224"
                  v-model="formulario.manutencaoRSCabMachos1224"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Machos 24-36 meses</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoCabecaMachos2436"
                  v-model="formulario.manutencaoCabecaMachos2436"
                  type="number"
                  background-color="white"
                  label="Cab"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoKGVivoMachos2436"
                  v-model="formulario.manutencaoKGVivoMachos2436"
                  type="number"
                  background-color="white"
                  label="Kg vivo/cab"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoRSCabMachos2436"
                  v-model="formulario.manutencaoRSCabMachos2436"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Machos +36 meses inclusive tourunos</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoCabecaMachos36tourunos"
                  v-model="formulario.manutencaoCabecaMachos36tourunos"
                  type="number"
                  background-color="white"
                  label="Cab"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoKGVivoMachos36tourunos"
                  v-model="formulario.manutencaoKGVivoMachos36tourunos"
                  type="number"
                  background-color="white"
                  label="Kg vivo/cab"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoRSCabMachos36tourunos"
                  v-model="formulario.manutencaoRSCabMachos36tourunos"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Suplementos</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Sal mineral</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoSalMineral"
                  v-model="formulario.manutencaoSalMineral"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Sal proteinado</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoSalProteinado"
                  v-model="formulario.manutencaoSalProteinado"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Ração (Concentrado)</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoRacao"
                  v-model="formulario.manutencaoRacao"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Outros</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoOutros"
                  v-model="formulario.manutencaoOutros"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Produtos veterinários</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Vacinas</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoVacinas"
                  v-model="formulario.manutencaoVacinas"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Vermifugos</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoVermifugos"
                  v-model="formulario.manutencaoVermifugos"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Medicamentos</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoMedicamentos"
                  v-model="formulario.manutencaoMedicamentos"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Outros</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoOutrosprodutosVeterinarios"
                  v-model="formulario.manutencaoOutrosprodutosVeterinarios"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Inseminação artificial ou outros</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Insumos</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoInsumos"
                  v-model="formulario.manutencaoInsumos"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs10 sm4 md4>
            <div class="divider2 text-xs-center">
              <span>
                <b>Mão de obra</b>
              </span>
            </div>
            <v-divider></v-divider>

            <v-layout align-center justify row wrap>
              <v-flex xs6 sm5 md5>
                <v-text-field
                  name="manutencaoMaoDeObra"
                  v-model="formulario.manutencaoMaoDeObra"
                  type="number"
                  background-color="white"
                  label="R$/ano"
                  box
                ></v-text-field>
                {{form}}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-form>
  </v-panel>
</template>
<script>
/* eslint-disable */
import DadosDespesasAnimal from "../../class/DadosDespesasAnimal.js";
export default {
  inject: ["$validator"],
  data: () => ({
    formulario: new DadosDespesasAnimal(),
    panel: [],
    select: null,
    items: ["Sim", "Não"],
    lazy: true,
    valid: false,
    simulation: ''
  }),
  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed: {
    form: function() {
      this.$db.simulation.get({ code: this.simulation.code }, dado => {
        this.formulario = new DadosDespesasAnimal(dado.dadosDespesasAnimal);
      });
    }
  },
  methods: {
    clear() {
      this.formulario = {
        formulario: Object.assign(this.$data, this.$options.data.apply())
      };
      this.$validator.reset();
    }
  }
};
</script>
<style scoped>
h2 {
  color: #00695c;
}

.botaoNone {
  border: solid black 1px;
  position: fixed;
  margin-bottom: 0;
  z-index: 997;
  bottom: 45px;
  right: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

@media screen and (max-width: 991px) {
  h2 {
    color: #00695c;
  }
  .container {
    position: relative;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;

    color: azure;
  }

  .panel {
    margin-top: 1%;
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 15px black;
  }
  .form {
    margin-top: 2%;

    min-width: 100%;
  }
  .text-field {
    background-color: blue;
    font-size: 2px;
  }
  .select {
    background-color: blue;
    font-size: 2px;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }
  .button {
    float: right;
  }
  .divider {
    text-align: center;
    font-size: 130%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    margin-top: 5%;
    margin-left: 5%;
    font-size: 110%;
  }
}

@media screen and (min-width: 992px) {
  h2 {
    color: #00695c;
  }
  .container {
    margin-top: 2%;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;

    color: azure;
  }
  .panel {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 10px black;
  }
  .panelGrafico {
    width: 70%;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }

  .button {
    float: right;
  }

  .divider {
    text-align: center;
    font-size: 180%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    font-size: 150%;
    margin-top: 5%;
    margin-left: 5%;
  }
  .layout {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>